import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import { useForm, Controller } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import { sendRequest } from "../../util/httpClient";
import { Notification } from "../common/Notification";
import {
    userInsuranceServiceList,
    assurantProductType,
    assurantAddonCount,
    nyServiceList,
    nyPackageList,
    nyIdfServiceList,
    insuranceFileNy,
} from "../../config/UserServicesList";
import * as MyAccountActions from "../../store/myAccount/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as ProtectionPlanActions from "../../store/protectionPlanService/ezs/actions";
import * as services from "../../store/service";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";
import { isIDFPartnerUser } from "../../util/partner";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import SubmitReportConfirmationDialog from "../Dialogs/SubmitReportConfirmationDialog";
import Insurance from "./Insurance";
import InsuranceIDF from "./InsuranceIDF";
import ErrorBoundary from "../common/ErrorBoundary";
import { DialogComponent } from "../common/DialogComponent";
import { useCheckAnyServiceActive } from "../../util/CommonServices";
import { Link } from "react-router-dom";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import TwitterXIcon from "../../Assets/images/icon-x-color.svg";
import { isValidPhoneNo } from "../../util/phoneNumberValidationUtil";
import { useTranslation } from "react-i18next";

interface IProps {
    setForm: any;
    supportIdentityThreatState: any;
    setSupportIdentityThreatState: any;
    onClose: any;
}

const Support = ({ setForm, setSupportIdentityThreatState, supportIdentityThreatState, onClose }: IProps) => {
    const dispatch = useDispatch();
    const [pkg, setPkg] = useState<{ isActive: boolean; packageCode: string }>();
    const [isIDFNYPackage, setIsIDFNYPackage] = useState(false);
    const [memeberId, setMemeberId] = useState("");
    const [useNewInsuranceLogic, setUseNewInsuranceLogic] = useState(false);
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation());
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const protectionPlanSelector = useSelector((state: ApplicationState) => state.protectionPlanState);

    const isServiceActive = (serviceDisplayName: string, state: ApplicationState) => {
        const services =
            state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
                ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices
                : [];
        const selectedService = services.find((service) => service.displayName === serviceDisplayName);
        if (selectedService && selectedService.active) {
            return true;
        }
        return false;
    };
    const isNYStateUser = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.isNYStateUser : false) : false
    );
    const MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_ONE_LINE: number = 32;
    const MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_WRAP_IN_TWO_LINE: number = 2 * MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_ONE_LINE;
    const [isLoading, setLoading] = useState(false);
    const [isInsuranceLoading, setIsInsuranceLoading] = useState(false);
    const [showQuebecMessage, setShowQuebecMessage] = useState(false);

    // const [errorMsg, seterrorMsg] = useState("");
    // const [hasError, setHasError] = useState(false);
    const [submitReportConfirmationDialog, setSubmitReportConfirmationDialog] = useState(false);
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );
    const partnerBusinessPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.businessPhoneNumber
            ? state.configurationState.configuration.partnerConfig.businessPhoneNumber
            : ""
    );
    const retailerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );
    const partnerEmail = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.email ? state.configurationState.configuration.partnerConfig.email : ""
    );
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : []) : []
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const userPhone =
        accountInfo?._personalAccountInformation != null ? accountInfo._personalAccountInformation.primaryPhone : accountInfo != null ? accountInfo.phone : null;
    const userState = accountInfo != null ? accountInfo.state : "";
    const userCountry = accountInfo != null ? accountInfo.country : "";
    const isCyberscoutCanadaPartner = useSelector((state: ApplicationState): boolean => {
        const partnerId: number | undefined =
            state.configurationState?.configuration?.partnerConfig?.partnerId;

        return partnerId !== undefined && [2597, 2686].includes(partnerId);
    });
    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const isIDFFamilyServiceActive = useSelector((state: ApplicationState) => isServiceActive("Family", state));
    const isIDFFamilyChildActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Child", state));
    const isIDFFamilySpouseActive = useSelector((state: ApplicationState) => isServiceActive("Family 3.0 Spouse", state));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    let isCallAPIForDownloadInsurance = false;
    let insuranceServiceKey = "";
    let insurancePrice = "";
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const parentPrimaryPhone = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userInfo ? (state.loggedInUser.userInfo.phoneNumber ? state.loggedInUser.userInfo.phoneNumber : "") : "") : ""
    );
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const partnerProvider = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
        ) {
            return "IDF";
        }
        return "EZS";
    });
    const isIDFGovernmentPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2655
                ? true
                : false
            : false
    );
    const isIDFLife360Partner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );

    const isShowSocialConnectUsOnlineModule = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isShowSocialConnectUsOnlineModule
            ? state.configurationState.configuration.partnerConfig.isShowSocialConnectUsOnlineModule
            : false
    );

    const isRetailerPhoneNumberHide = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isRetailerPhoneNumberHide
            ? state.configurationState.configuration.partnerConfig.isRetailerPhoneNumberHide
            : false
    );

    const { t: tLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    let language =
        !!partnerLanguageOptions && partnerLanguageOptions.length > 1
            ? // ignoring 'prefered' as this is misspelled from API side
              // eslint-disable-next-line spellcheck/spell-checker
              document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                ? !!document.cookie
                      .split(";")
                      // eslint-disable-next-line spellcheck/spell-checker
                      .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                      .split("=")[1]
                    ? document.cookie
                          .split(";")
                          // eslint-disable-next-line spellcheck/spell-checker
                          .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                          .split("=")[1]
                    : "en"
                : "en"
            : "en";
    const currentLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : language
    );

    const ssnText = currentLanguage === "fr" && (userCountry === "CA" || isCyberscoutCanadaPartner) ? "NAS" : userCountry === "CA" && isCyberscoutCanadaPartner ? "SIN" : "SSN";

    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );

    const isMWBId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2664
                ? true
                : false
            : false
    );

    const hideHelpCenterWidget = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2640 ||
              state.configurationState.configuration.partnerConfig.partnerId === 1557 ||
              state.configurationState.configuration.partnerConfig.partnerId === 2597
                ? true
                : false
            : false
    );

    const getPackage = () => {
        setLoading(true);
        services.getActiveOfferDetails().then((data) => {
            setPkg(data);
            setLoading(false);
            if (data && nyPackageList.includes(data.packageCode)) {
                setIsIDFNYPackage(true);
            }
        });
    };
    const getMemberId = () => {
        services.getMonitoring().then((data) => {
            if (data) {
                setMemeberId(data["ezshield-id"]);
            }
        });
    };

    const getNewInsuranceLogic = () => {
        const serviceCodes = userServices?.map((s: any) => s.serviceCode) ?? [];
        const hasAnyCode = (list: string[]) => serviceCodes.some((code) => list.includes(code));

        if (partnerProvider === "IDF") {
            const serviceCodeExceptions = ["id-fraud1m", "id-fraud50k", "id-fraud25k", "identity-theft-insurance1m", "identity-theft-insurance25k"];
            const life360EligibleCodes = ["eri25k", "eri1m"];
            const hasException = hasAnyCode(serviceCodeExceptions);
            const hasLife360Eligible = hasAnyCode(life360EligibleCodes);
            const shouldUseNewLogic = !hasException && (!isIDFLife360Partner || (isIDFLife360Partner && userCountry === "CA" && hasLife360Eligible));

            if (shouldUseNewLogic) {
                setUseNewInsuranceLogic(true);
            }

            return;
        }

        const serviceCodeExceptions = [
            "SVC-401K-FAM-1MUEFT-NC",
            "SVC-401K-FAM-CYB-1MUEFT-NC",
            "SVC-401K-FAM-2MUEFT-NC",
            "SVC-401K-FAM-CYB-2MUEFT-NC",
            "SVC-IDFraud-FAM-2M-TRIO-NY",
            "SVC-IDFraud-FAM-1M-TRIO-NY",
            "SVC-IDFraud-FAM-2M-NC",
            "SVC-IDFraud-FAM-2MUEFT-NC",
            "SVC-IDFraud-1M-NC",
            "SVC-IDFraud-5M-NC",
            "SVC-IDFraud-5MUEFT-NC",
            "SVC-IDFraud-1MUEFT-NC",
            "SVC-IDFraud-FAM-2MNC-TRIO-NY",
            "SVC-IDFraud-FAM-1MNC-TRIO-NY",
            "SVCLVL-IDR-IND-1MM",
            "SVCLVL-IDR-FAM-1MM",
            "SVC-ITI-FAM-1M-NY",
            "SVC-TUAIG-1M-NY",
            "id-fraud1m",
            "id-fraud50k",
            "id-fraud25k",
            "identity-theft-insurance1m",
            "identity-theft-insurance25k",
        ];

        const hasException = hasAnyCode(serviceCodeExceptions);

        // All non-IDF partners now use new logic unless they're a government partner or have an exception
        const shouldUseNewLogic = !isIDFGovernmentPartner && !hasException;

        if (shouldUseNewLogic) {
            setUseNewInsuranceLogic(true);
        }
    };

    const getIsUserPaid = (packageList: any) => {
        let activeObject = null;
        for (let i = 0; i < packageList.length; i++) {
            if (packageList[i].IsActive === true) {
                activeObject = packageList[i];
                break;
            }
        }
        if (activeObject.IsUserPaid) {
            setShowQuebecMessage(true);
        }
        setIsInsuranceLoading(false);
    };

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        getAccountInformation();
        getPackage();
        getMemberId();
        getNewInsuranceLogic();

        // show loader and call API to determine if Canada/Quebec user isUserPaid or not
        if (userCountry === "CA" && userState === "QC") {
            setIsInsuranceLoading(true);
            requestProtectionPlan(false);
        }
    }, []);

    useEffect(() => {
        if (protectionPlanSelector.protectionPlanData && protectionPlanSelector.protectionPlanData.packageList && userCountry === "CA" && userState === "QC") {
            getIsUserPaid(protectionPlanSelector.protectionPlanData.packageList);
        }
    }, [protectionPlanSelector]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const checkFamilyServiceActive = () => {
        if (
            userServices &&
            userServices.filter((service: any) => ["SVC-EXPINS-1M", "SVC-EXPINS-2M", "SVC-EXPINS-25k"].indexOf(service.serviceCode) >= 0 && service.active).length >
                0
        ) {
            return "";
        }
        if (isFamilyProtectionServiceActive || isIDFFamilyServiceActive || isIDFFamilyChildActive || isIDFFamilySpouseActive) {
            return "per family plan";
        }
        return "per individual";
    };

    // fetch data from GetUserServiceInsuranceTerms API and trigger file download
    // @note - applys only to IDF specific service code "ifraud1m" & "idfraud25k"
    const getUserServiceInsuranceTerms = () => {
        services.GetUserServiceInsuranceTerms(insuranceServiceKey).then((data: string) => {
            if (data != null) {
                // decode the data
                const binaryString = window.atob(data);
                const binaryLen = binaryString.length;
                const bytes = new Uint8Array(binaryLen);
                for (let i = 0; i < binaryLen; i++) {
                    const ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }

                const arrBuffer = bytes;
                const filename = "SummaryOfBenefits.pdf";
                // It is necessary to create a new blob object with mime-type explicitly set
                // otherwise only Chrome works like it should
                const blob = new Blob([arrBuffer], { type: "application/pdf" });
                const _win = window.navigator as any;
                // save file to disk if user is using IE/Edge
                if (navigator.appVersion.toString().indexOf(".NET") > 0) _win.msSaveBlob(blob, filename);
                // create an anchor link with a file download path and trigger click event to start download
                else {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                }
            } else {
                Notification({
                    type: "Not Found",
                    title: "Insurance Terms",
                    message: "Your insurance terms document not found.",
                });
            }
        });
    };
    const { register, handleSubmit, errors, watch, setValue, control } = useForm({
        mode: "onBlur",
    });
    const CyberActiveServices = useAreServicesActive([ezsServiceIds.businessBreachFulfillmentSupport]);
    const IncidenceActiveServices = useAreServicesActive([ezsServiceIds.businessIncidentResponseForensics]);
    const userInfo = useSelector((state: ApplicationState) => {
        if (state.loggedInUser !== null) {
            return {
                firstName: state.loggedInUser?.activeAccount?.firstName,
                lastName: state.loggedInUser?.activeAccount?.lastName,
                email: state.loggedInUser?.userInfo?.EmailAddress,
                phoneNumber: isPrimaryAccount ? userPhone?.replace("1-", "") : parentPrimaryPhone,
            };
        }
        return { firstName: "", lastName: "", email: "", phoneNumber: "" };
    });

    const onSubmit = (reportIdentityThreat: any) => {
        setLoading(true);
        const requestBody = {
            firstName: reportIdentityThreat["FirstName"],
            lastName: reportIdentityThreat["LastName"],
            email: reportIdentityThreat["Email"],
            phoneNumber: getCountryInfo() ? reportIdentityThreat["Phone"].replace(/[^0-9+]/g, "") : reportIdentityThreat["Phone"],
            message: reportIdentityThreat["EmailBody"],
        };
        return sendRequest("post", "api/userServices/reportIdentityThreat", requestBody)
            .then((data) => {
                setLoading(false);
                if (data.isSuccess) {
                    setValue("EmailBody", "");
                    setSubmitReportConfirmationDialog(true);
                } else if (data.hasError && data.errorMessage.length > 0) {
                    // @TODO commented out for now as UI is doing nothing with these values
                    // seterrorMsg(data.errorMessage);
                    // setHasError(true);
                } else {
                    // seterrorMsg("Unknown Error");
                    // setHasError(true);
                }
            })
            .catch(function (error) {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: error,
                    duration: 0,
                });
                closeDialog();
            });
    };

    // fetch data from generatepdf API and trigger file download
    // @note - applys only to NY specific service codes(SVC-IDFraud-FAM-1M-TRIO-NY, SVC-IDFraud-FAM-2M-TRIO-NY) using the below insurance documents
    // "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $1M FAMILY 1.25.24.pdf",
    // "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $2M FAMILY 1.25.24.pdf"
    const getGeneratedPdf = (fileName: string) => {
        services
            .generatedPdfService({
                memberID: memeberId,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                address: accountInfo
                    ? `${accountInfo.address1}${accountInfo.address2 ? `, ${accountInfo.address2}` : ""}${accountInfo.city ? `, ${accountInfo.city}` : ""}${
                          accountInfo.state ? `, ${accountInfo.state} ${accountInfo.zipCode}` : ""
                      }, ${accountInfo.country}`
                    : "",
                signUpDate: accountInfo ? accountInfo.accountCreationDate : "",
                limit: insuranceFileNy[0] === fileName ? "1M" : "2M",
            })
            .then((data: any) => {
                const binaryString = window.atob(data);
                const binaryLen = binaryString.length;
                const bytes = new Uint8Array(binaryLen);
                for (let i = 0; i < binaryLen; i++) {
                    const ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                const arrBuffer = bytes;
                const blob = new Blob([arrBuffer], { type: "application/pdf" });
                const _win = window.navigator as any;
                if (navigator.appVersion.toString().indexOf(".NET") > 0) _win.msSaveBlob(blob, fileName);
                else {
                    let url = window.URL.createObjectURL(blob);
                    window.open(url, "_blank");
                    // let a = document.createElement("a");
                    // a.href = url;
                    // a.download = fileName;
                    // a.click();
                }
            });
    };

    const getDescription = (description: string) => {
        return description.toUpperCase().includes("$1M")
            ? "$1 million"
            : description.toUpperCase().includes("$25K")
            ? "$25,000"
            : description.toUpperCase().includes("$50K")
            ? "$50,000"
            : description.toUpperCase().includes("$2M")
            ? "$2 million"
            : description.toUpperCase().includes("$5M")
            ? "$5 million"
            : "";
    };

    const insuranceFilePath = () => {
        if (userServices && userServices.length > 0) {
            for (const insurance of userInsuranceServiceList) {
                const id = insurance.serviceCode.toLowerCase().replace("-", "");
                let serviceCode = "";

                // match service code from users package with service code in userInsuranceServiceList array
                // @note - if service code matches with a service code from nyServiceList, handle separately by returning null
                const service = userServices.find((service) => {
                    serviceCode = service && service.serviceCode ? service.serviceCode.replace("-", "") : "";
                    serviceCode = serviceCode.toLowerCase();
                    if (serviceCode === id && service.active) {
                        if (nyServiceList.includes(service && service.serviceCode ? service.serviceCode : "") && !isNYStateUser) {
                            return null;
                        }

                        return service;
                    }
                    return null;
                });

                // match service code from users package with service code in nyServiceList array
                // @note - returns array of active ny insurance variants
                const nyInsuranceServices = userServices.filter(
                    (service: any) =>
                        nyServiceList.indexOf(service.serviceCode) >= 0 &&
                        service.active &&
                        nyServiceList.includes(service && service.serviceCode ? service.serviceCode : "")
                );

                // determines whether to return IDF NY price/document or non-IDF price/document
                if (nyInsuranceServices.length > 0 && isNYStateUser) {
                    const currentInsurance = userInsuranceServiceList.filter((item) => item.serviceCode === nyInsuranceServices[0].serviceCode);
                    const nyIdfInsurance = nyIdfServiceList.filter((item) => item.serviceCode === nyInsuranceServices[0].serviceCode);

                    // if active NY service code is idf and matched in nyPackageList array, pull price/document out of matched object
                    // @note - returns price/document from matched idf specific ny variant
                    if (pkg && nyPackageList.includes(pkg.packageCode) && nyIdfInsurance.length > 0) {
                        insurancePrice = nyIdfInsurance ? getDescription(nyIdfInsurance[0].insuranceDocument) : "";
                        return nyIdfInsurance ? nyIdfInsurance[0].insuranceDocument : "";
                    }
                    // else return non-idf service price/document
                    insurancePrice = currentInsurance ? getDescription(currentInsurance[0].insuranceDocument) : "";
                    return currentInsurance ? currentInsurance[0].insuranceDocument : "";
                }

                // match service code from users package with specific reimbursement service codes
                // @TODO - figure out why this is separate
                const newInsuranceServices = userServices.filter(
                    (service: any) => ["SVC-RNSM-REIMB", "SVC-SOCENG-REIMB"].indexOf(service.serviceCode) >= 0 && service.active
                );
                const newCyberbullying25kService = userServices.filter((service: any) => ["SVC-CB-25K"].indexOf(service.serviceCode) >= 0 && service.active);
                const newCyberbullying50kService = userServices.filter((service: any) => ["SVC-CB-50K"].indexOf(service.serviceCode) >= 0 && service.active);
                if (service && serviceCode === id) {
                    insurancePrice = insurance.serviceDescription.toUpperCase().includes("$1M")
                        ? "$1 million"
                        : insurance.serviceDescription.toUpperCase().includes("$25K")
                        ? "$25,000"
                        : insurance.serviceDescription.toUpperCase().includes("$50K")
                        ? "$50,000"
                        : insurance.serviceDescription.toUpperCase().includes("$2M")
                        ? "$2 million"
                        : insurance.serviceDescription.toUpperCase().includes("$5M")
                        ? "$5 million"
                        : "";

                    // handle specific 'advanced' scenario for IDF service code
                    // @note - uses additional service level configurations tied to a single service code
                    if (serviceCode === "idfraud1m") {
                        const featureDatas = service.serviceFeatures;
                        let assAddonCount = null;
                        let assProductType = null;

                        if (featureDatas != null && featureDatas.length > 0) {
                            for (const featureData of featureDatas) {
                                if (featureData.key === assurantAddonCount.name) {
                                    assAddonCount = featureData.value;
                                }

                                if (featureData.key === assurantProductType.name) {
                                    assProductType = featureData.value;
                                }
                            }

                            if (assAddonCount === insurance.assurantAddonCount && assProductType === insurance.assurantProductType) {
                                if (userState === insurance.state) {
                                    isCallAPIForDownloadInsurance = true;
                                    insuranceServiceKey = "id-fraud1m";
                                    return null;
                                } else if (insurance.state === "") {
                                    return insurance.insuranceDocument;
                                }
                            } else if (serviceCode === "idfraud1m") {
                                if (userState === "TX" || userState === "NY") {
                                    isCallAPIForDownloadInsurance = true;
                                    insuranceServiceKey = "id-fraud1m";
                                    return null;
                                }
                            }
                        }
                        // set flag to call API for insurance document for specific IDF service code
                    } else if (serviceCode === "idfraud25k") {
                        if (userState === "TX" || userState === "NY") {
                            isCallAPIForDownloadInsurance = true;
                            insuranceServiceKey = "id-fraud25k";
                            return null;
                        }
                        // sets path to insurance file for specific scenarios where package also contains "SVC-RNSM-REIMB", "SVC-SOCENG-REIMB" service code
                    } else if (newInsuranceServices.length > 0) {
                        // if "SVC-CB-25K" service code active, return insurance document path based on price set above
                        if (newCyberbullying25kService.length > 0) {
                            const insuranceFile =
                                insurancePrice === "$1 million" ? "Summary SOC $1M SE RW 25CB 2023-1.pdf" : "Summary SOC $2M SE RW 25CB 2023-1.pdf";
                            return insuranceFile;
                            // if "SVC-CB-50K" service code active, return insurance document path based on price set above
                        } else if (newCyberbullying50kService.length > 0) {
                            const insuranceFile =
                                insurancePrice === "$1 million" ? "Summary SOC $1M SE RW 50CB 2023-1.pdf" : "Summary SOC $2M SE RW 50CB 2023-1.pdf";
                            return insuranceFile;
                        } else {
                            const insuranceFile = insurancePrice === "$1 million" ? "Summary SOC $1M SE RW 2023-1.pdf" : "Summary SOC $2M SE RW 2023-1.pdf";
                            return insuranceFile;
                        }
                        // return normal insurance document path tied to the service codes configuration object in userInsuranceServiceList
                    } else {
                        return insurance.insuranceDocument;
                    }
                }
            }
        }
        return null;
    };

    const usrInsuranceFilePath = insuranceFilePath();
    const isShowInsuranceSection = (usrInsuranceFilePath != null && usrInsuranceFilePath.length > 0) || isCallAPIForDownloadInsurance ? true : false;
    const insuranceMembership = checkFamilyServiceActive();

    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";

        if (currentCountry.includes("US") || currentCountry.includes("CA") || currentCountry === "") {
            return false;
        } else {
            return true;
        }
    };

    const handleSubscriptionChangeDialog = (value: string): any => {
        setSubmitReportConfirmationDialog(false);
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch {}
        }
    }, []);

    return (
        <React.Fragment>
            <ErrorBoundary componentName="Protection Plan Upgrade Confirmation Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                {submitReportConfirmationDialog && (
                    <DialogComponent
                        dialogId="protection-plan-upgrade-confirmation-dialog"
                        title="Upgrade Confirmation"
                        datalayerEvent="Protection Plan - Close confirmation"
                        closeDialog={() => {
                            handleSubscriptionChangeDialog("close");
                        }}
                    >
                        <SubmitReportConfirmationDialog
                            closeDialog={() => {
                                handleSubscriptionChangeDialog("close");
                            }}
                        />
                    </DialogComponent>
                )}
            </ErrorBoundary>

            <div className=" row">
                <div className="col-xs-12 row">
                    {(!CyberActiveServices || !IncidenceActiveServices) && (
                        <h1 className="title-page" id="support-page" tabIndex={-1}>
                            {tLang("supportSection.supportTitleText")}
                        </h1>
                    )}
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs col-no-gutter">
                    <div className="row">
                        {useCheckAnyServiceActive() ? (
                            <div className={isIDFPartner ? "col-xs-12 col-sm-12" : "col-xs-12 col-sm-7 col-md-8 col-lg-8"}>
                                {!isIDFPartner && (
                                    <div className="box">
                                        <div className="box-header">
                                            <div className="box-title-container">
                                                <div className="box-title-text">
                                                    <h2 className="box-title">{tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.title")}</h2>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={isLoading ? "box-content loading" : "box-content"}>
                                            <form name="report-identity-threat" onSubmit={handleSubmit(onSubmit)} id="report-identity-threat">
                                                <div className="row row-split-2">
                                                    <div className={`col-xs-12 col-no-gutter col-sm ${errors["FirstName"] && "status-error"}`}>
                                                        <div className="form-row">
                                                            <div className="form-label">
                                                                <label htmlFor="first-name-label">
                                                                    {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.label.firstName")}{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input">
                                                                <input
                                                                    type="text"
                                                                    name="FirstName"
                                                                    className="inputbox support-input"
                                                                    id="first-name-label"
                                                                    defaultValue={userInfo?.firstName}
                                                                    placeholder={tLang(
                                                                        "supportSection.generalSupportWidget.reportIdentityThreatWidget.placeholder.firstName"
                                                                    )}
                                                                    ref={register({ pattern: PATTERNS.FIRSTNAME.pattern, required: true })}
                                                                    aria-required="true"
                                                                />
                                                                {!!errors["FirstName"] && errors["FirstName"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.firstName.required"
                                                                        )}
                                                                    </span>
                                                                )}
                                                                {!!errors["FirstName"] && errors["FirstName"].type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.firstName.pattern"
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`col-xs-12 col-no-gutter col-sm ${errors["LastName"] && "status-error"}`}>
                                                        <div className="form-row">
                                                            <div className="form-label">
                                                                <label htmlFor="last-name-label">
                                                                    {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.label.lastName")}{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input">
                                                                <input
                                                                    type="text"
                                                                    name="LastName"
                                                                    className="inputbox support-input"
                                                                    id="last-name-label"
                                                                    defaultValue={userInfo?.lastName}
                                                                    placeholder={tLang(
                                                                        "supportSection.generalSupportWidget.reportIdentityThreatWidget.placeholder.lastName"
                                                                    )}
                                                                    ref={register({ pattern: PATTERNS.LASTNAME.pattern, required: true })}
                                                                    aria-required="true"
                                                                />
                                                                {!!errors["LastName"] && errors["LastName"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.lastName.required"
                                                                        )}
                                                                    </span>
                                                                )}
                                                                {!!errors["LastName"] && errors["LastName"].type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.lastName.pattern"
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row row-split-2">
                                                    <div className={`col-xs-12 col-no-gutter col-sm ${errors["Email"] && "status-error"}`}>
                                                        <div className="form-row">
                                                            <div className="form-label">
                                                                <label htmlFor="email-label">
                                                                    {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.label.email")}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input">
                                                                <input
                                                                    type="text"
                                                                    name="Email"
                                                                    className="inputbox support-input"
                                                                    id="email-label"
                                                                    defaultValue={userInfo?.email}
                                                                    placeholder={tLang(
                                                                        "supportSection.generalSupportWidget.reportIdentityThreatWidget.placeholder.email"
                                                                    )}
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: PATTERNS.EMAIL.pattern,
                                                                    })}
                                                                    aria-required="true"
                                                                />
                                                                {!!errors["Email"] && errors["Email"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.email.required"
                                                                        )}
                                                                    </span>
                                                                )}
                                                                {!!errors["Email"] && errors["Email"].type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.email.pattern"
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-no-gutter col-sm">
                                                        <div
                                                            role="alert"
                                                            className={`form-row ${errors["Phone"] && "status-error"} ${
                                                                errors["Phone"] && watch("Phone") && !parsePhoneNumber(watch("Phone")) ? "country-error" : ""
                                                            }`}
                                                        >
                                                            <div className="form-label">
                                                                <label htmlFor="phone-number-label-support">
                                                                    {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.label.phone")}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            {userInfo && (
                                                                <div className="form-input">
                                                                    <Controller
                                                                        name={`Phone`}
                                                                        control={control}
                                                                        defaultValue={userInfo ? String(userInfo.phoneNumber) : ""}
                                                                        className="inputbox support-input"
                                                                        rules={{
                                                                            required: true,
                                                                            validate: (value) =>
                                                                                value
                                                                                    ? isValidPhoneNo(
                                                                                          accountInfo && accountInfo.country ? accountInfo.country : "US",
                                                                                          value
                                                                                      )
                                                                                    : false,
                                                                        }}
                                                                        render={({ onChange, value }) => (
                                                                            <PhoneInput
                                                                                value={value}
                                                                                onChange={onChange}
                                                                                international={false}
                                                                                addInternationalOption={false}
                                                                                defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                                countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                                id="phone-number-label-support"
                                                                                placeholder={tLang(
                                                                                    "supportSection.generalSupportWidget.reportIdentityThreatWidget.placeholder.phone"
                                                                                )}
                                                                                maxLength={15}
                                                                                minLength={10}
                                                                                aria-required="true"
                                                                            />
                                                                        )}
                                                                    />
                                                                    {!!errors["Phone"] && errors["Phone"].type === "required" && (
                                                                        <span className="form-error">
                                                                            {tLang(
                                                                                "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.phone.required"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                    {!!errors["Phone"] && errors["Phone"].type === "validate" && (
                                                                        <span className="form-error">
                                                                            {tLang(
                                                                                "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.phone.pattern"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                    {!!errors["Phone"] && errors["Phone"].type === "minLength" && (
                                                                        <span className="form-error">
                                                                            {tLang(
                                                                                "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.phone.minLength"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                    {!!errors["Phone"] && errors["Phone"].type === "maxLength" && (
                                                                        <span className="form-error">
                                                                            {tLang(
                                                                                "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.phone.maxLength"
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter col-sm">
                                                        <div className={`form-row ${errors["Phone"] && "status-error"}`}>
                                                            <div className="form-label">
                                                                <label htmlFor="what-happened-label">
                                                                    {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.label.whatHappened")}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input">
                                                                <textarea
                                                                    className="inputbox support-input"
                                                                    name="EmailBody"
                                                                    id="what-happened-label"
                                                                    placeholder={tLang(
                                                                        "supportSection.generalSupportWidget.reportIdentityThreatWidget.placeholder.whatHappened"
                                                                    )}
                                                                    rows={6}
                                                                    ref={register({
                                                                        required: true,
                                                                    })}
                                                                    aria-required="true"
                                                                />
                                                                {!!errors["EmailBody"] && errors["EmailBody"].type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang(
                                                                            "supportSection.generalSupportWidget.reportIdentityThreatWidget.validationMessage.whatHappened.required"
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <p className="support-note padding-bottom-l">
                                                        <b> {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.supportnote.boldNote")}</b>,{" "}
                                                        {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.supportnote.note", {ssnText:ssnText})}
                                                    </p>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs col-no-gutter">
                                                        <button type="submit" className="btn-default btn-primary">
                                                            <span className="btn-text">
                                                                {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.buttonText")}
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                )}
                                {isShowInsuranceSection && !isLoading ? (
                                    <>
                                        {useNewInsuranceLogic ? (
                                            partnerProvider === "IDF" ? (
                                                <InsuranceIDF
                                                    userServices={userServices}
                                                    userState={userState ? userState : ""}
                                                    userCountry={userCountry ? userCountry : ""}
                                                    isNYStateUser={isNYStateUser ? isNYStateUser : false}
                                                    isIDFPartner={isIDFPartner}
                                                    isAvastId={isAvastId}
                                                    isAVGId={isAVGId}
                                                    isAVGTestId={isAVGTestId}
                                                    isInsuranceLoading={isInsuranceLoading}
                                                    insuranceMembership={insuranceMembership}
                                                    currentLanguage={currentLanguage}
                                                />
                                            ) : (
                                                <Insurance
                                                    userServices={userServices}
                                                    userState={userState ? userState : ""}
                                                    userCountry={userCountry ? userCountry : ""}
                                                    isNYStateUser={isNYStateUser ? isNYStateUser : false}
                                                    isIDFNYPackage={isIDFNYPackage}
                                                    isIDFPartner={isIDFPartner}
                                                    isAvastId={isAvastId}
                                                    isAVGId={isAVGId}
                                                    isAVGTestId={isAVGTestId}
                                                    isInsuranceLoading={isInsuranceLoading}
                                                    insuranceMembership={insuranceMembership}
                                                    currentLanguage={currentLanguage}
                                                    getGeneratedPdf={getGeneratedPdf}
                                                />
                                            )
                                        ) : (
                                            <div className={isIDFPartner ? "box box-border-top" : "box"}>
                                                <div className="box-header">
                                                    <div className="box-title-container">
                                                        <div className="box-title-text">
                                                            <h2 className="box-title" id="credit-score-trend-title">
                                                                {isAvastId || isAVGId || isAVGTestId
                                                                    ? "Expense Reimbursement "
                                                                    : tLang("supportSection.insuranceTitleText")}
                                                            </h2>
                                                        </div>
                                                    </div>
                                                    <div className="box-description"></div>
                                                    <div className="box-actions"></div>
                                                </div>
                                                {isInsuranceLoading ? (
                                                    <div className="box-content loading"></div>
                                                ) : (
                                                    <div className="box-content">
                                                        {showQuebecMessage ? (
                                                            <p>Insurance is unavailable to user-paid members in Quebec</p>
                                                        ) : (
                                                            <>
                                                                <p>
                                                                    {tLang("supportSection.generalSupportWidget.insuranceContent.message.initialText")}{" "}
                                                                    {insurancePrice}{" "}
                                                                    {tLang("supportSection.generalSupportWidget.insuranceContent.message.middleText")}
                                                                    {isAvastId || isAVGId || isAVGTestId ? "reimbursement " : " insurance"}{" "}
                                                                    {tLang("supportSection.generalSupportWidget.insuranceContent.message.lastText")}
                                                                </p>

                                                                <p id="footnote-label">
                                                                    <small id="footnotes">
                                                                        {tLang("supportSection.generalSupportWidget.insuranceContent.notification.initialText")}{" "}
                                                                        {isAvastId || isAVGId || isAVGTestId ? "reimbursement " : "insurance"}{" "}
                                                                        {tLang("supportSection.generalSupportWidget.insuranceContent.notification.lastText")}
                                                                    </small>
                                                                </p>
                                                                {currentLanguage === "fr" ? (
                                                                    <p>{tLang("supportSection.generalSupportWidget.insuranceContent.message.languageText")}</p>
                                                                ) : (
                                                                    <p>
                                                                        {tLang("supportSection.generalSupportWidget.insuranceContent.link.content")}{" "}
                                                                        {isCallAPIForDownloadInsurance ? (
                                                                            <a
                                                                                type="button"
                                                                                className="default_link"
                                                                                href="javascript:void(0);"
                                                                                onClick={() => getUserServiceInsuranceTerms()}
                                                                            >
                                                                                <span className="btn-text">view your Summary of Benefits here.</span>
                                                                            </a>
                                                                        ) : (
                                                                            <a
                                                                                type="button"
                                                                                target="_blank"
                                                                                className="default_link"
                                                                                onClick={(e) => {
                                                                                    if (usrInsuranceFilePath && insuranceFileNy.includes(usrInsuranceFilePath)) {
                                                                                        e.preventDefault();
                                                                                        getGeneratedPdf(usrInsuranceFilePath);
                                                                                    }
                                                                                }}
                                                                                href={"doc/" + usrInsuranceFilePath}
                                                                                rel="noreferrer"
                                                                            >
                                                                                <span className="btn-text">
                                                                                    {tLang("supportSection.generalSupportWidget.insuranceContent.link.buttonText")}
                                                                                </span>
                                                                            </a>
                                                                        )}
                                                                    </p>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        ) : (
                            <div className={isIDFPartner ? "col-xs-12 col-sm-12" : "col-xs-12 col-sm-8"}>
                                <div className="box-content" style={{ backgroundColor: "#FFF", width: "100%", padding: "30px" }}>
                                    <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                                        <div className="box-header col-xs-12 col-sm-12 ">
                                            <div className="content-sub-title text-align-center">
                                                <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                    <em className="las la-exclamation-circle "></em>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-content text-align-center">
                                            <p>{tLang("dashboard.noServiceActive.message")}</p>
                                            <p>
                                                <Link to="/manage-account/protection-plan" className="default_link">
                                                    {tLang("dashboard.noServiceActive.protectionPlanLink")}
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Right side cards*/}
                        <div className={"col-xs-12 " + (isIDFPartner ? "col-sm-12" : "col-sm-5 col-md-4 col-lg-4")}>
                            <div className="box box-border-top">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-text">
                                            <h3 className="box-title">
                                                {isMWBId ? (
                                                    "Have Questions?"
                                                ) : (
                                                    <>
                                                        {tLang("supportSection.generalSupportWidget.dedicatedResolutionSpecialist.title1")}
                                                        <br />
                                                        {tLang("supportSection.generalSupportWidget.dedicatedResolutionSpecialist.title2")}
                                                    </>
                                                )}
                                            </h3>
                                        </div>
                                        <div className="box-title-icon position-right" aria-hidden="true">
                                            <RenderIcons iconName="user-alt" />
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content">
                                    {!isRetailerPhoneNumberHide && (
                                        <p>
                                            {tLang("supportSection.generalSupportWidget.dedicatedResolutionSpecialist.callText")}
                                            {""}
                                            <span className="emphasize-1">
                                                {retailerPhoneNumber.length > 0 ? retailerPhoneNumber : isBusinessUser ? partnerBusinessPhone : partnerPhone}
                                            </span>
                                        </p>
                                    )}

                                    {/* Show alternative phone number only for Malwarebytes partner */}
                                    {!isRetailerPhoneNumberHide && isMWBId && (
                                        <p>
                                            <strong>If calling from outside the United States:</strong>
                                            {""}
                                            <span className="emphasize-1">708-649-0391</span>
                                        </p>
                                    )}
                                    <p>
                                        {tLang("supportSection.generalSupportWidget.dedicatedResolutionSpecialist.emailText")} <br />
                                        {partnerEmail && partnerEmail.length < 21 && (
                                            <span className="emphasize-3">
                                                <a
                                                    href={
                                                        "mailto:" +
                                                        partnerEmail +
                                                        "?body=***For your safety, do not reply with any sensitive information, such as your SSN or account numbers.***"
                                                    }
                                                    className="default_link"
                                                >
                                                    {partnerEmail}
                                                </a>
                                            </span>
                                        )}
                                        {partnerEmail && partnerEmail.length > 20 && (
                                            <span className="emphasize-5">
                                                <strong style={{ fontSize: "90%" }}>
                                                    <a
                                                        href={
                                                            "mailto:" +
                                                            partnerEmail +
                                                            "?body=***For your safety, do not reply with any sensitive information, such as your SSN or account numbers.***"
                                                        }
                                                        className="default_link"
                                                    >
                                                        <span>{partnerEmail.substring(0, MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_ONE_LINE)}</span>
                                                        <br />
                                                        <span>
                                                            {partnerEmail.substring(
                                                                MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_ONE_LINE,
                                                                partnerEmail.length < MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_WRAP_IN_TWO_LINE
                                                                    ? partnerEmail.length
                                                                    : MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_WRAP_IN_TWO_LINE
                                                            )}
                                                        </span>
                                                        {partnerEmail.length > MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_WRAP_IN_TWO_LINE && (
                                                            <>
                                                                <br />
                                                                <span>
                                                                    {partnerEmail.substring(MAXIMUM_SUPPORT_EMAIL_LENGTH_FOR_WRAP_IN_TWO_LINE, partnerEmail.length)}
                                                                </span>
                                                            </>
                                                        )}
                                                    </a>
                                                </strong>
                                            </span>
                                        )}
                                    </p>
                                    <p className="support-note">
                                        <b> {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.supportnote.boldNote")}</b>,{" "}
                                        {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.supportnote.note", {ssnText:ssnText})}
                                    </p>
                                </div>
                            </div>

                            {isShowSocialConnectUsOnlineModule ? (
                                <div className="box box-border-top">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon position-right" aria-hidden="true">
                                                <RenderIcons iconName="users" />
                                            </div>
                                            <div className="box-title-text">
                                                <h3 className="box-title">Connect with us Online</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <p>Follow us online to be kept up to date with all the latest offerings.</p>

                                        <ul className="list-reset list-inline">
                                            <li>
                                                <a
                                                    type="button"
                                                    className="btn-default btn-twitter btn-no-padding btn-border-round btn-no-border btn-icon-only"
                                                    href="https://x.com/Sontiq1"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="btn-icon">
                                                        <img src={TwitterXIcon} alt="X icon" />
                                                    </span>
                                                    <span className="btn-text">Follow us on X</span>
                                                </a>
                                            </li>
                                            <li className="margin-left-xs">
                                                <a
                                                    type="button"
                                                    className="btn-default btn-facebook btn-no-padding btn-border-round btn-no-border btn-icon-only"
                                                    href="https://www.facebook.com/Sontiq1/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="btn-icon">
                                                        <em className="lab la-facebook-f"></em>
                                                    </span>
                                                    <span className="btn-text">Follow us on Facebook</span>
                                                </a>
                                            </li>
                                            <li className="margin-left-xs">
                                                <a
                                                    type="button"
                                                    className="btn-default btn-linkedin btn-no-padding btn-border-round btn-no-border btn-icon-only"
                                                    href="https://www.linkedin.com/company/sontiq/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="btn-icon">
                                                        <em className="lab la-linkedin-in"></em>
                                                    </span>
                                                    <span className="btn-text">Follow us on Linkedin</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                            {!isWhiteLabeled && currentLanguage === "en" && !hideHelpCenterWidget ? (
                                <div className="box box-border-top">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon position-right" aria-hidden="true">
                                                <RenderIcons iconName="question" />
                                            </div>
                                            <div className="box-title-text">
                                                <h3 className="box-title">{tLang("supportSection.generalSupportWidget.helpWidget.helpCenterTitle")}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <p>Find answers to frequently asked questions about your account and protection.</p>
                                        <p className="text-align-center">
                                            <a
                                                type="button"
                                                className="btn-default btn-primary-outline"
                                                target="_blank"
                                                href="https://helpcenter.sontiq.com"
                                                rel="noreferrer"
                                            >
                                                <span className="btn-text">{tLang("supportSection.generalSupportWidget.helpWidget.accessHelpCenterButton")}</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Support;
